export default __webpack_public_path__ + "static/media/parkingrampe4.9e205562.png";